export default __webpack_public_path__ + "static/media/img04.3f9d7b3e.png";